import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const allergyRoutes = [
  {
    path: "/directories/allergy",
    name: "AllergyList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "allergy" */ "./components/List"),
  },
];
